import React, { PureComponent } from 'react'
import { Grid, InputLabel } from '@material-ui/core'
import { EditableTextField } from '../common/EditableComponents'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class PaymentModal extends PureComponent {
  state = {}

  onClose = () => {
    this.setState({})
  }

  onOpen = (type) => {
    this.setState({})
  }

  render() {
    const { forwardedRef, rowData } = this.props

    return (
      <ModalDialog
        title={'Payment Detail'}
        ref={forwardedRef}
        // onConfirm={this.addShop}
        onClose={this.onClose}
        onOpen={this.onOpen}
        hideSave={true}
      >
        <Grid container spacing={3} justify="space-around">
          <Grid item lg={12}>
            <InputLabel>Period: </InputLabel>
            <EditableTextField
              value={rowData.period}
              valueToRender={rowData.period}
              editMode={false}
            />
          </Grid>
          <Grid item lg={12}>
            <InputLabel>Date: </InputLabel>
            <EditableTextField value={rowData.date} valueToRender={rowData.date} editMode={false} />
          </Grid>
          <Grid item lg={12}>
            <InputLabel>Payment Method: </InputLabel>
            <EditableTextField
              value={rowData.source}
              valueToRender={rowData.source}
              editMode={false}
            />
          </Grid>
          <Grid item lg={12}>
            <InputLabel>Amount: </InputLabel>
            <EditableTextField
              value={rowData.amount}
              valueToRender={rowData.amount}
              editMode={false}
            />
          </Grid>
          <Grid item lg={12}>
            <InputLabel>Subscription: </InputLabel>
            <EditableTextField
              value={rowData.description}
              valueToRender={rowData.description}
              editMode={false}
            />
          </Grid>
          <Grid item lg={12}>
            <InputLabel>Status: </InputLabel>
            <EditableTextField
              value={rowData.status}
              valueToRender={rowData.status}
              editMode={false}
            />
          </Grid>
        </Grid>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(PaymentModal)



// WEBPACK FOOTER //
// ./src/components/Modal/PaymentModal.js